
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg } from 'html-to-image';



import Lock from './../images/lock.svg';


import OverviewIcon from './../images/tab-images/overview.svg';
import StrengthsIcon from './../images/tab-images/strengths-weak.svg';
import ComboIcon from './../images/tab-images/combos.svg';
import RelationshipsIcon from './../images/tab-images/relationships.svg';
import JobsIcon from './../images/tab-images/jobs.svg';

import Logo from './../images/logo.png';

import O from './../images/ope.png';
import O2 from './../images/clo.png';
import C from './../images/conc.png';
import C2 from './../images/unc.png';
import E from './../images/ext.png';
import E2 from './../images/int.png';
import A from './../images/agr.png';
import A2 from './../images/dis.png';
import S from './../images/sta.png';
import S2 from './../images/neu.png';

import OpeClo from './../images/ope_clo.png';
import ConUnc from './../images/con_unc.png';
import ExtInt from './../images/ext_int.png';
import AgrDis from './../images/agr_dis.png';
import EmoNeu from './../images/emo_neu.png';

import DownloadIcon from './../images/image-black.png';


import {
  FacebookShareButton,
} from "react-share";

import {
  FacebookIcon,
} from "react-share";




import React from 'react';
import { useState, useEffect } from 'react';
import { useRef } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import ResultChart from './../components/result-chart';
import ResultImage from './../components/result-image';


import Spinner from './../components/spinner';

import Strengths from './results-components/results-strengths.jsx';
import Tabs from './results-components/results-tabs.jsx';
import OverviewTab from './results-components/overview-tab.jsx';
import CombinationsTab from './results-components/combinations-tab.jsx';
import StrengthsTab from './results-components/strengths-tab.jsx';
import RelationshipsTab from './results-components/relationships-tab.jsx';
import JobsTab from './results-components/jobs-tab.jsx';

import ShareCanvas from './../components/share-canvas';


import './results.scss';
import './pre-test.scss';
import './../global-variables.scss';


import { motion } from 'framer-motion';



const Results = ({ personalityData, setModalOpen, setPremiumModalOpen, loading, isPaid }) => {

  const [selectedTab, setSelectedTab] = useState('overview');

  const canvasRef = useRef(null);

  const imageWhileHoverAnimation = {
    y: [null, -5, 0],
    transition: { duration: 0.3 },
  };

  let personalityDataExists = true;

  let opeTitle;
  let conTitle;
  let extTitle;
  let agrTitle;
  let staTitle;

  const canvasWidth = '800';
  const canvasHeight = '500';



  if (personalityData == null) {
    personalityData = ({ "ope": 4, "con": 4, "ext": 4, "agr": 4, "sta": 4 });
    personalityDataExists = false;
  }

  const opeLevel = personalityData.ope;
  const conLevel = personalityData.con;
  const extLevel = personalityData.ext;
  const agrLevel = personalityData.agr;
  const staLevel = personalityData.sta;

  //console.log("opelevel=" + opeLevel);

  //const opeLevel = 4; 
  //const conLevel = 4; 
  //const extLevel = 4; 
  //const agrLevel = 4;
  //const staLevel = 4; 

  if (opeLevel <= 1) {
    opeTitle = "Highly practical";

  }
  else if (opeLevel <= 2) {
    opeTitle = "Moderately practical";

  }
  else if (opeLevel <= 3) {
    opeTitle = "Somewhat practical";

  }
  else if (opeLevel <= 4) {
    opeTitle = "Pragmatic";

  }
  else if (opeLevel <= 5) {
    opeTitle = "Somewhat curious";

  }
  else if (opeLevel <= 6) {
    opeTitle = "Moderately curious";

  }
  else if (opeLevel <= 7) {
    opeTitle = "Highly curious";

  }


  if (conLevel <= 1) {
    conTitle = "Highly unstructured";

  }
  else if (conLevel <= 2) {
    conTitle = "Moderately unstructured";

  }
  else if (conLevel <= 3) {
    conTitle = "Somewhat unstructured";

  }
  else if (conLevel <= 4) {
    conTitle = "Balanced";

  }
  else if (conLevel <= 5) {
    conTitle = "Somewhat structured";

  }
  else if (conLevel <= 6) {
    conTitle = "Moderately structured";

  }
  else if (conLevel <= 7) {
    conTitle = "Highly structured";

  }



  if (extLevel <= 1) {
    extTitle = "Highly introverted";

  }
  else if (extLevel <= 2) {
    extTitle = "Moderately introverted";

  }
  else if (extLevel <= 3) {
    extTitle = "Somewhat introverted";

  }
  else if (extLevel <= 4) {
    extTitle = "Ambivert";

  }
  else if (extLevel <= 5) {
    extTitle = "Somewhat extraverted";

  }
  else if (extLevel <= 6) {
    extTitle = "Moderately extraverted";

  }
  else if (extLevel <= 7) {
    extTitle = "Highly extraverted";

  }




  if (agrLevel <= 1) {
    agrTitle = "Highly disagreeable";

  }
  else if (agrLevel <= 2) {
    agrTitle = "Moderately disagreeable";

  }
  else if (agrLevel <= 3) {
    agrTitle = "Somewhat disagreeable";

  }
  else if (agrLevel <= 4) {
    agrTitle = "Adaptable";

  }
  else if (agrLevel <= 5) {
    agrTitle = "Somewhat agreeable";

  }
  else if (agrLevel <= 6) {
    agrTitle = "Moderately agreeable";

  }
  else if (agrLevel <= 7) {
    agrTitle = "Highly agreeable";

  }




  if (staLevel <= 1) {
    staTitle = "Highly sensitive";

  }
  else if (staLevel <= 2) {
    staTitle = "Moderately sensitive";

  }
  else if (staLevel <= 3) {
    staTitle = "Somewhat sensitive";

  }
  else if (staLevel <= 4) {
    staTitle = "Emotionally balanced";

  }
  else if (staLevel <= 5) {
    staTitle = "Somewhat emotionally stable";

  }
  else if (staLevel <= 6) {
    staTitle = "Moderately emotionally stable";

  }
  else if (staLevel <= 7) {
    staTitle = "Highly emotionally stable";

  }




  let opeLogo;
  let conLogo;
  let extLogo;
  let agrLogo;
  let staLogo;


  let tabLogo;


  //setting correct headline logo

  if (selectedTab == 'overview') {
    tabLogo = OverviewIcon;
  }
  else if (selectedTab == 'strengths') {
    tabLogo = StrengthsIcon;
  }
  else if (selectedTab == 'combinations') {
    tabLogo = ComboIcon;
  }
  else if (selectedTab == 'relationships') {
    tabLogo = RelationshipsIcon;
  }
  else {
    tabLogo = JobsIcon;
  }





  // setting correct logos

  if (opeLevel < 4) {
    opeLogo = O2;

  }
  else if (opeLevel > 4) {
    opeLogo = O;

  }
  else {
    opeLogo = OpeClo;

  }

  if (conLevel < 4) {
    conLogo = C2;

  }
  else if (conLevel > 4) {
    conLogo = C;

  }
  else {
    conLogo = ConUnc;

  }

  if (extLevel < 4) {
    extLogo = E2;

  }
  else if (extLevel > 4) {
    extLogo = E;

  }
  else {
    extLogo = ExtInt;

  }

  if (agrLevel < 4) {
    agrLogo = A2;

  }
  else if (agrLevel > 4) {
    agrLogo = A;

  }
  else {
    agrLogo = AgrDis;

  }

  if (staLevel < 4) {
    staLogo = S2;

  }
  else if (staLevel > 4) {
    staLogo = S;

  }
  else {
    staLogo = EmoNeu;

  }


  const downloadImage = () => {
    const canvas = canvasRef.current;

    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'my-bigfive-results.png';

      document.body.appendChild(link);
      link.click();

      //cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 'image/png');
  }


  const shareImage = () => {

    const canvas = canvasRef.current;

    // 1. Convert canvas to blob
    canvas.toBlob(async (blob) => {
      // 2. Upload to your server/cloud storage
      const formData = new FormData();
      formData.append('image', blob, 'image.png');

      const response = await fetch('/api/upload-image', {
        method: 'POST',
        body: formData
      });

      const { imageUrl } = await response.json();

      // 3. Open share URL for the platform
      const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imageUrl)}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(imageUrl)}&text=Check%20this%20out!`,
        reddit: `https://reddit.com/submit?url=${encodeURIComponent(imageUrl)}`,
        pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(imageUrl)}&media=${encodeURIComponent(imageUrl)}`,
      };

      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imageUrl)}`, '_blank', 'width=800,height=500');
    }, 'image/png');

  }





  return (
    <div className="results">

      <ShareCanvas personalityData={personalityData} isPaid={isPaid} canvasRef={canvasRef} canvasWidth={parseInt(canvasWidth)} canvasHeight={parseInt(canvasHeight)}
        opeTitle={opeTitle} opeLogo={opeLogo} conTitle={conTitle} conLogo={conLogo} extTitle={extTitle} extLogo={extLogo} agrTitle={agrTitle} agrLogo={agrLogo}
        staTitle={staTitle} staLogo={staLogo} />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >


        <div className="heading-section" >



          <div className="flex-divider">
            <img src={Logo} className="bigfive-logo" alt="logo" />
            <div>
              <h1 className="heading-section-title"> {(isPaid == true) ? <>Your premium results</> : <>Your results </>}</h1>
            </div>
          </div>
        </div>



      </motion.div>

      {(loading == false) ?

        <div>

          {personalityDataExists ?

            <div>

              <ResultsIcons opeLogo={opeLogo} opeTitle={opeTitle} conLogo={conLogo} conTitle={conTitle} extLogo={extLogo} extTitle={extTitle}
                agrTitle={agrTitle} agrLogo={agrLogo} staLogo={staLogo} staTitle={staTitle} />

                
              <div className="share-bar">
                <button className="button special small" onClick={() => {
                  downloadImage()
                }}>
                  <div className="button-text" >  Download results </div>
                  <img className="button-icon" src={DownloadIcon} alt="download" />
                </button>
              </div>

              {/* Hidden canvas for the image when you download results */}
              {/*<canvas ref={canvasRef} width={canvasWidth} height={canvasHeight} />*/}
              <canvas ref={canvasRef} width={canvasWidth} height={canvasHeight} style={{ display: 'none' }} />

              <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} setPremiumModalOpen={setPremiumModalOpen} isPaid={isPaid} />

              <div className="vertical-spacer" />
              <hr />

              <motion.div className="tab-title"
                initial={{ opacity: 0 }}
                key={selectedTab}
                animate={
                  { opacity: 1, transition: { delay: 0.1 } }}>
                < img className="tab-title-icon" src={tabLogo} />
                <div className="title"> {selectedTab} </div>
              </motion.div>

              <hr />

              <ResultsTabSection personalityData={personalityData} opeLevel={opeLevel} conLevel={conLevel} extLevel={extLevel}
                agrLevel={agrLevel} staLevel={staLevel}
                selectedTab={selectedTab} opeTitle={opeTitle} opeLogo={opeLogo}
                conTitle={conTitle} conLogo={conLogo} agrTitle={agrTitle}
                agrLogo={agrLogo} extTitle={extTitle} extLogo={extLogo} staTitle={staTitle} staLogo={staLogo}

                setPremiumModalOpen={setPremiumModalOpen}
                isPaid={isPaid} />


              <hr />
              <div className="vertical-spacer" />


              <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} setPremiumModalOpen={setPremiumModalOpen} isPaid={isPaid} />



              {/*
          <div className="reset-test-text" onClick={() => { setModalOpen(true) }}>
            Delete results and retake test
          </div>
          */}

            </div>

            :

            <div className="flex-center"> No personality data</div>

          }

        </div>

        :

        <div className="flex-center">
          <Spinner />
        </div>





      }
    </div>
  );
}



const ResultsTabSection = ({ personalityData, opeLevel, conLevel, extLevel,
  agrLevel, staLevel, selectedTab, opeTitle, opeLogo, conTitle, conLogo, agrTitle,
  agrLogo, extTitle, extLogo, staTitle, staLogo, setPremiumModalOpen, isPaid }) => {

  if (selectedTab == 'overview') {
    return (

      <OverviewTab personalityData={personalityData} isPaid={isPaid} />
    );
  }
  else if (selectedTab == 'combinations') {
    return (

      <CombinationsTab opeLevel={opeLevel} conLevel={conLevel} extLevel={extLevel}
        agrLevel={agrLevel} staLevel={staLevel} setPremiumModalOpen={setPremiumModalOpen} isPaid={isPaid} />
    );
  }
  else if (selectedTab == 'strengths') {
    return (
      <StrengthsTab personalityData={personalityData}

        opeLevel={opeLevel} conLevel={conLevel} extLevel={extLevel}
        agrLevel={agrLevel} staLevel={staLevel}

        opeTitle={opeTitle} opeLogo={opeLogo} conTitle={conTitle} conLogo={conLogo} agrTitle={agrTitle}
        agrLogo={agrLogo} extTitle={extTitle} extLogo={extLogo} staTitle={staTitle} staLogo={staLogo}
        setPremiumModalOpen={setPremiumModalOpen}
        isPaid={isPaid} />
    );
  }
  else if (selectedTab == 'relationships') {
    return (

      <RelationshipsTab personalityData={personalityData}

        opeLevel={opeLevel} conLevel={conLevel} extLevel={extLevel}
        agrLevel={agrLevel} staLevel={staLevel}

        opeTitle={opeTitle} opeLogo={opeLogo} conTitle={conTitle} conLogo={conLogo} agrTitle={agrTitle}
        agrLogo={agrLogo} extTitle={extTitle} extLogo={extLogo} staTitle={staTitle} staLogo={staLogo} isPaid={isPaid} />
    );
  }
  else {
    return (
      <JobsTab personalityData={personalityData}
        opeLevel={opeLevel} conLevel={conLevel} extLevel={extLevel}
        agrLevel={agrLevel} staLevel={staLevel}

        opeTitle={opeTitle} opeLogo={opeLogo} conTitle={conTitle} conLogo={conLogo} agrTitle={agrTitle}
        agrLogo={agrLogo} extTitle={extTitle} extLogo={extLogo} staTitle={staTitle} staLogo={staLogo} isPaid={isPaid} />
    );
  }

}

const ResultsIcons = ({ opeLogo, opeTitle, conLogo, conTitle, extLogo, extTitle, agrTitle, agrLogo, staLogo, staTitle }) => {

  return (

    <div className="result-icons" id="to-export">

      <motion.div className="result"
        initial={{ opacity: 0, y: -10 }}
        animate={
          { opacity: 1, y: 0, transition: { delay: 0.1 } }}

      >
        <motion.img className="result-icon" src={opeLogo} alt="logo"
          whileHover={
            {
              y: [null, -5, 0],
              transition: { duration: 0.3 },
            }
          }
        />
        <h4 className="result-text">
          {opeTitle}
        </h4>


      </motion.div>
      <motion.div className="result"
        initial={{ opacity: 0, y: -10 }}
        animate={
          { opacity: 1, y: 0, transition: { delay: 0.2 } }}

      >
        <motion.img className="result-icon" src={conLogo} alt="logo"
          whileHover={
            {
              y: [null, -5, 0],
              transition: { duration: 0.3 },
            }
          } />
        <h4 className="result-text">
          {conTitle}
        </h4>

      </motion.div>
      <motion.div className="result"
        initial={{ opacity: 0, y: -10 }}
        animate={
          { opacity: 1, y: 0, transition: { delay: 0.3 } }}
      >
        <motion.img className="result-icon" src={extLogo} alt="logo"
          whileHover={
            {
              y: [null, -5, 0],
              transition: { duration: 0.3 },
            }
          }
        />
        <h4 className="result-text">
          {extTitle}
        </h4>

      </motion.div>
      <motion.div className="result"
        initial={{ opacity: 0, y: -10 }}
        animate={
          { opacity: 1, y: 0, transition: { delay: 0.4 } }}
      >
        <motion.img className="result-icon" src={agrLogo} alt="logo"
          whileHover={
            {
              y: [null, -5, 0],
              transition: { duration: 0.3 },
            }
          } />
        <h4 className="result-text">
          {agrTitle}
        </h4>

      </motion.div>
      <motion.div className="result"
        initial={{ opacity: 0, y: -10 }}
        animate={
          { opacity: 1, y: 0, transition: { delay: 0.5 } }}
      >
        <motion.img className="result-icon" src={staLogo} alt="logo"
          whileHover={
            {
              y: [null, -5, 0],
              transition: { duration: 0.3 },
            }
          }
        />
        <h4 className="result-text">
          {staTitle}
        </h4>

      </motion.div>


    </div>

  )
}


export default Results;